export default {
    namespace: 'Footer',
    translations: {
        zh: {
            logoText: '未来世界',
            officeLabel: '东京办公室',
            officeAddress: '東京都北区田端新町3-7-6 中田第3ビルB1F',
            phoneLabel: '电话',
            phone: '080-9981-0852',
            emailLabel: '邮箱',
            email: 'contact@fw-robot.com',
            sections: {
                primary: '快速导航',
                resources: '资源内容'
            },
            links: {
                corePeople: '核心人物'
            },
            languageLabel: '当前语言：{{language}}',
            copyright: 'Copyright 2025 - 株式会社日本ミライワールド All Rights Reserved.'
        },
        en: {
            logoText: 'FUTURE WORLD',
            officeLabel: 'Tokyo Office',
            officeAddress: 'Nakada No.3 Building B1F, 3-7-6 Tabata Shinmachi, Kita-ku, Tokyo',
            phoneLabel: 'Phone',
            phone: '080-9981-0852',
            emailLabel: 'Email',
            email: 'contact@fw-robot.com',
            sections: {
                primary: 'Quick Links',
                resources: 'Resources'
            },
            links: {
                corePeople: 'Core People'
            },
            languageLabel: 'Current language: {{language}}',
            copyright: 'Copyright 2025 - Japan Mirai World Co., Ltd. All Rights Reserved.'
        },
        ja: {
            logoText: 'ミライワールド',
            officeLabel: '東京オフィス',
            officeAddress: '東京都北区田端新町3-7-6 中田第3ビルB1F',
            phoneLabel: '電話',
            phone: '080-9981-0852',
            emailLabel: 'メール',
            email: 'contact@fw-robot.com',
            sections: {
                primary: 'クイックナビ',
                resources: 'リソース'
            },
            links: {
                corePeople: 'コアメンバー'
            },
            languageLabel: '現在の言語：{{language}}',
            copyright: 'Copyright 2025 - 株式会社日本ミライワールド All Rights Reserved.'
        }
    }
};
